module.exports = __webpack_public_path__ + "static/media/m6.34efad65.png";